import jwtDecode from "jwt-decode";
import { IToken } from "../types/common/TRole";

export function getRole() {
  const token = localStorage.getItem("Access-token");
  if (token) {
    const decodedJWT = jwtDecode<IToken>(token);
    //console.log(decodedJWT.role)
    return decodedJWT.role;
  }
}
